module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.4-component-preview.e227950c.png";